var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBzRenewableEnergy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57 47.77a16.19 16.19 0 01-17 13V69h-4V52.91A16.19 16.19 0 0118.52 40 16.19 16.19 0 0136 48.19V36.93a12.89 12.89 0 01-11-12.67V19h4V9a2 2 0 114 0v10h10V9a2 2 0 114 0v10h4v5.26A12.79 12.79 0 0140 37v18.21a16.18 16.18 0 0117-7.47v.03z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/BZ_Renewable_energy.78a8303a.svg";
export { SvgBzRenewableEnergy as ReactComponent };